import { ReactElement } from 'react'
import { DomainAssetsInterface } from 'shared/types/domain'
import { baseServerSideProps } from 'shared/utils/base-server-side-props'
import { WithCustomDomainResult, withCustomDomain } from 'shared/utils/with-custom-domain'
import { withDomainAssets } from 'shared/utils/with-domain-assets'
import { getAuthenticationLayout } from 'modules/authentication/layout/get-auhentication-layout'
import { RegisterForm } from 'modules/authentication/register/components/register-form'
import { RegisterFormDashboard } from 'modules/authentication/register/components/register-form-dashboard'

const Register = ({ hasCustomDomain }: WithCustomDomainResult) => {
  return hasCustomDomain ? <RegisterForm /> : <RegisterFormDashboard />
}

export const getServerSideProps = withCustomDomain(withDomainAssets(baseServerSideProps))

Register.getLayout = (
  page: ReactElement,
  props: { domainAssets?: DomainAssetsInterface } & WithCustomDomainResult,
) =>
  getAuthenticationLayout(page, {
    titleKey: 'security.registration.page_title',
    domainAssets: props.domainAssets,
    hasCustomDomain: props.hasCustomDomain,
  })

export default Register
